<span class="interaction-type">
	<mat-icon>{{ interaction().typeIcon }}</mat-icon>
	{{ interaction().type }}
</span>
<span>{{ interaction().date | date }}</span>

@if (interaction().topics.length) {
	<div class="topics">
		<div class="topics-title">Topics Discussed</div>
		<app-topic-buttons [topics]="interaction().topics" />
	</div>
}
